import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {BaseValue} from '@mintdata/mint-kit/api/values/BaseValue';
import {serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export class ACurrency extends BaseValue
{
    @serializable public readonly value:number;
    @serializable public readonly isoCode:string;

    // TODO: define enum with ISO codes
    public constructor(value:number, isoCode:string = 'USD')
    {
        super(Type.Currency);
        this.value = value;
        this.isoCode = isoCode;
    }

    public toString():string
    {
        return this.value != null ? this.value.toString() : null;
    }

    public toValue():string
    {
        return `{"value":${this.value}}`;
    }

    public isEqualTo(other:IValue):boolean
    {
        return other &&
            Type.isInstanceOf(other, Type.Currency) &&
            this.value === (other as ACurrency).value;
    }

    public compareTo(other:IValue):number
    {
        if( !other ) return 1;
        if( Type.isInstanceOf(other, Type.Error) || Type.isInstanceOf(other, Type.Empty) )
        {
            return 1;
        }
        if( this.isEqualTo(other) )
            return 0;

        if( Type.isInstanceOf(other, Type.Currency) )
        {
            return (this.value > (other as ACurrency).value) ? 1 : -1;
        }

        return -1;
    }

    public clone():IValue
    {
        return new ACurrency(this.value);
    }

    public static fromNumber(value:number):ACurrency
    {
        return new ACurrency(value);
    }

    public static circularRefResolver(value:string):IValue
    {
        // KEEP_ALIVE! Fix for resolving import circular dependencies for AError and ABaseValue
        return new AError('ERROR: Deprecated');
    }
}
